import { memo, useRef } from 'react';

import { cn } from '../../lib/styles';

export type TableListItemVariant = 'default' | 'inverted';

export interface TableListItemProps {
  label: React.ReactNode;
  value: React.ReactNode;
  actions?: React.ReactNode;
  alwaysDisplayActions?: boolean;
  className?: string;
  onValueClick?: () => void;
}

const TableListItemBase = ({
  label,
  value,
  actions,
  alwaysDisplayActions = false,
  className,
  onValueClick,
}: TableListItemProps) => {
  const valueRef = useRef<HTMLDivElement>(null);

  return (
    <div className={cn('flex flex-wrap items-start gap-x-5 border-b border-border-tertiary group', className)}>
      <div data-slot="label" className={cn('pt-4 font-body-md text-text-primary font-semibold min-w-[280px]')}>
        {label}
      </div>

      <div className="flex-1 py-1">
        <div
          ref={valueRef}
          data-slot="value"
          className={cn(
            '-mx-3 font-body-md relative text-text-primary p-3 rounded-sm hover:bg-bg-sur-secondary transition-all',
            'max-w-[798px] min-w-[500px]',
          )}
          onClick={onValueClick}
        >
          <div>{value}</div>

          {actions && (
            <div
              data-slot="actions"
              onClick={onValueClick ? (event) => event.stopPropagation() : undefined}
              className={cn(
                'transition-all absolute right-4 -top-6 z-10',
                'opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto focus-within:pointer-events-auto focus-within:opacity-100',
                {
                  'opacity-100 pointer-events-auto': alwaysDisplayActions,
                },
              )}
            >
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const TableListItem = memo(TableListItemBase);
